import { makeStyles } from '@material-ui/core';

const styles = () => ({
  row: {
    marginBottom: 16
  }
});

export default makeStyles(styles);
